// Constant for the Max number of saved element in the storage
export const MAX_NUMBER_EVENTS = 10;

// It can be use to see if the event was already consumed
export enum EVENT_STATUS {
	NEW = 'new',
	OLD = 'old',
	MODIFIED = 'modified'
}

export enum SIGNAL_STATUS {
	ONLINE = 'ONLINE',
	OFFLINE = 'OFFLINE'
}

export class SignalREventsModel {
	event: string;
	data: any;
	timestamp: number;
	status: string;
}

export interface SignalRModel {
	/**
	 * Contains list of latest events
	 */
	channels: any;
	lastConnection: number;
	connectionId: number;
	status: string;
}

export class ChannelConfigModel {
	streamLimit?: number;
	events?: any[];

	constructor(streamLimit?: number, events?: any) {
		this.streamLimit = streamLimit || MAX_NUMBER_EVENTS;
		this.events = events || [];
	}
}
